<template>
  <InstagramToolPage
    h1-title="Instagram Viewer"
    subtitle="Preview supported public Instagram posts and Reels by pasting a link—no login required."
    input-placeholder="Instagram username or public Instagram link"
    action-label="View"
    loading-label="Loading..."
    limitation-note="Public posts and Reels only. Private accounts are not supported."
    :view-mode="true"
    :show-download-actions="false"
    current-tool-path="/instagram-viewer/"
    :faqs="faqs"
  >
    <ToolContentSections :sections="viewerSections" />
  </InstagramToolPage>
</template>

<script>
import InstagramToolPage from '@/components/InstagramToolPage.vue';
import ToolContentSections from '@/components/ToolContentSections.vue';
import { viewerSections } from '@/data/instagram-tool-page-content';

export default {
  name: 'InstagramViewerPage',
  components: { InstagramToolPage, ToolContentSections },
  data () {
    return {
      viewerSections,
      faqs: [
        {
          question: 'What is an Instagram Viewer?',
          answer: 'It is a simple way to preview public Instagram media when you paste a direct post or Reel link. It does not replace the Instagram app or unlock private profiles.',
        },
        {
          question: 'Can I view private Instagram accounts?',
          answer: 'No. SnapInsta only works with content Instagram still serves publicly for the URL you provide.',
        },
        {
          question: 'Do I need an Instagram account?',
          answer: 'Not for supported public links. If Instagram requires login for that URL, the preview will not load here either.',
        },
        {
          question: 'Can I view Instagram Reels?',
          answer: 'Yes, when you paste a public Reel link (instagram.com/reel/…). The preview shows the video Instagram returns for that URL.',
        },
        {
          question: 'Why can’t a profile be found?',
          answer: 'This page needs a link to a specific post or Reel. A username alone does not load a full profile grid. Open the profile on instagram.com or copy a link from an individual public post.',
        },
      ],
    };
  },
};
</script>
